var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cube-page',{attrs:{"title":_vm.customerName}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('wmq-layout',{ref:"mainDashboard",attrs:{"rootLayoutConfig":_vm.configData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }